export default "__VITE_ASSET__CPdIu3iR__"